import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FileInputModule } from '@common/file-input/file-input.module';
import { AppMaterialModule } from './../app-material.module';
import { BlockDialogComponent } from '@common/block-dialog/block-dialog.component';
import { ConfirmationDialogComponent } from '@root/common/confirmation-dialog/confirmation-dialog.component';
import { FooterComponent } from '@root/common/footer/footer.component';
import { HeaderComponent } from '@root/common/header/header.component';
import { NavMenuComponent } from '@root/common/nav-menu/nav-menu.component';
import { SelectNotificationDialogComponent } from '@common/select-notification-dialog/select-notification-dialog.component';
import { SendNotificationConfirmationDialogComponent } from '@common/send-notification-confirmation-dialog/send-notification-confirmation-dialog.component';
import { ImageCropperModule } from 'ngx-image-cropper';
// -------------------------directive
import { AccessCheck } from '@common/access-check/access-check.directive';
// -------------------------pipe
import { SearchFilterPipe } from '@common/pipe/search-filter.pipe';
import { CropImageComponent } from './crop-image/crop-image.component';
@NgModule({
  declarations: [
    BlockDialogComponent,
    ConfirmationDialogComponent,
    HeaderComponent,
    FooterComponent,
    NavMenuComponent,
    SelectNotificationDialogComponent,
    SendNotificationConfirmationDialogComponent,
    //-----directives
    AccessCheck,
    // ----pipe
    SearchFilterPipe,
    CropImageComponent,
  ],
  imports: [CommonModule, FormsModule, FileInputModule, AppMaterialModule, ImageCropperModule],

  exports: [
    FileInputModule,
    AppMaterialModule,
    BlockDialogComponent,
    ConfirmationDialogComponent,
    HeaderComponent,
    FooterComponent,
    NavMenuComponent,
    SelectNotificationDialogComponent,
    SendNotificationConfirmationDialogComponent,
     //-----directives
     AccessCheck,
    // ----pipe
    SearchFilterPipe,
  ],
  entryComponents: [
    ConfirmationDialogComponent,
    BlockDialogComponent,
    SelectNotificationDialogComponent,
    SendNotificationConfirmationDialogComponent,
    CropImageComponent,
  ],
})
export class AppCommonModule {}
